import React from "react";
import PropTypes from "prop-types";

function ChartsGroup({ children }) {
  return (
    <div
      data-testid="charts-group"
      className="charts-container tw-flex tw-overflow-y-auto tw-flex-wrap tw-mt-0 tw-mx-0 tw-mb-8"
    >
      {children}
    </div>
  );
}

ChartsGroup.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element),
  ]).isRequired,
};

export default ChartsGroup;
